import { render } from "./Edition2024View.vue?vue&type=template&id=cb7ad2d8"
import script from "./Edition2024View.vue?vue&type=script&lang=js"
export * from "./Edition2024View.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__